import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { map } from "rxjs/operators";

const API_FRAUD_URL = environment.api.urlCoreAdmin

@Injectable({
    providedIn: 'root'
})
export class FraudService {

    constructor(private http: HttpClient) { }

    getFrauds(params?: any) {
        const url = `${API_FRAUD_URL}/v1/fraud/all${this.getParams(params)}`;
        return this.http.get(url).pipe(
            map((res) => {
                return res;
            })
        )
    };

    updateStatusFraud(fraudId:number, status: number) {
        const url = `${API_FRAUD_URL}/v1/fraud/update/${fraudId}`;
        const body = {
            status: status
        }
        return this.http.post(url, body).pipe(
            map((res: any) => res)
        );
    }

    getStatusFraud() {
        const url = `${API_FRAUD_URL}/v1/terms/list?key=STATUSANTIPHISHING`;
        return this.http.get(url).pipe(
            map((res) => {
                return res;
            })
        )
    }

    getParams(object) {
        if (object) {
            const parameters = [];
            for (const property in object) {
                if (object.hasOwnProperty(property)) {
                    if (object[property] && property != 'period') {
                        parameters.push(encodeURI(property + '=' + (object[property] ? object[property] : '')));
                    }
                }
            }
            return '?' + parameters.join('&');
        }
        return ''
    }
}